import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Reseller extends Page{
    constructor(){
        super({
            id : 'reseller',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}